import React, { Component, useEffect, useState } from 'react';
import logos from '../../images/PNRR_logos.svg';
import SGD_BW from '../../images/gender-diamond-2025_bw2.png'
import * as d3 from "d3";
import images from '../../data/images_data.json'

function Archive (props) {

    const color = {
        gray: 'rgb(200,200,200)',
        darkgray: 'rgb(200,200,200)',
        white: 'rgb(25,25,25)',
        highlight: 'rgb(15,15,15)'
    }

    function capitalize (string) {
        if (string) return string.charAt(0).toUpperCase() + string.slice(1);
        else return '–'
    }

    useEffect(() => {
        d3.select('#images').selectAll('.unit').data(images).join(
            function(enter){
                const unit = enter.append('div')
                    .attr('class', 'unit')
                    .style('background-color', d => d.correct ? color.white : color.highlight)

                unit.append('div')
                    .attr('class', 'unit_image')
                    .style('background-image', d => 'url("./img/portraits/'+ d.file+'")')
                
                const description = unit.append('div')
                    .style('padding', '3px')
                    .style('display', 'flex')
                    .style('flex-wrap', 'wrap')
                    .style('align-content', 'space-between')
                    .style('min-height', '95px')
                
                description.append('h5').style('color', color.darkgray).html(d => capitalize(d.prompt))

                const small = description.append('div').style('width', '100%')

                small.append('h6').attr('class', 'smallText').style('opacity', 0.3).html(d => d.model)
                small.append('h6').attr('class', 'smallText').style('opacity', 0.3).html(d => d.date)

                unit.on('mouseenter', function(){
                    // d3.selectAll('.unit_image').transition().style('filter', 'invert()')
                    d3.select(this).transition().duration(1000).ease(d3.easeCubicInOut)
                        .style('width', '150px')
                        .style('height', '250px')
                        
                    d3.select(this).select('.unit_image').transition().duration(1500).ease(d3.easeCubicInOut)
                        .style('height', '230px')
                        // .style('filter', undefined)

                })
                .on('mouseleave', function(){
                    // d3.selectAll('.unit_image').transition().style('filter', undefined)
                    d3.select(this).transition().duration(1500).ease(d3.easeCubicInOut)
                        .style('width', '100px')
                        .style('height', '200px')

                    d3.select(this).select('.unit_image').transition().duration(500).ease(d3.easeCubicInOut)
                        .style('height', '100px')
                })
            }
        )
    })

    return (
        <div id="archive">
            <div id="intro">
                <div style={{maxWidth: 750}}>
                    <p style={{fontSize: 30}}>NonbAInary is a <span className="special">systematic collection</span> of AI-generated stereotypical portraits across the gender spectrum and a <span className="special">though-provoking workshop</span> to critically engage with gender biases.</p>
                    <p style={{fontSize: 30}}>By organising labels through the Gender Diamond, the project proposes a <span className="special">nonbinary critical lens</span> to understand patterns of discriminations beyond dichotomies.</p>
                    <div style={{marginTop: 20, display: 'flex', gap: 20}}>
                        <h5>Researchers<br/>
                            —<br/><strong>Fe Simeoni<br/>María Menéndez-Blanco<br/>Antonella De Angeli</strong></h5>
                        <h5 style={{maxWidth: 250}}>Archive<br/>—<br/><strong>February–April 2024</strong><br/>—<br/><strong>Dall E<br/>Midjourney<br/>Stable Diffusion <br/>Artbreeder<br/>Runway</strong></h5>
                        <h5>Workshops<br/>—<br/><strong>April–June 2025<br/>—<br/>Vienna<br/>Bolzano<br/>Trento<br/>Roma<br/>Helsinki</strong></h5>
                    </div>
                </div>
                <div style={{flexGrow: 4, display: 'flex', justifyContent: 'center'}}>
                    <img src={SGD_BW} alt="Description" style={{mixBlendMode: 'lighten', maxWidth: 400, opacity: 0.85}}/>
                </div>
            </div>
            <img 
                src={logos} 
                style={{
                    mixBlendMode: 'lighten', 
                    width: '90%',
                    boxSizing: 'border-box',
                    maxWidth: 500, 
                    margin: '80px 15px 10px 10px',
                    opacity: 0.8
                }}
            />
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                <div id="images"></div>
            </div>
        </div>
    )
}

export default Archive;